export const WELCOME_INIT_VALUES = {
  mood: '',
};
